var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.775,
    height: 11.775,
    viewBox: "0 0 11.775 11.775",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-upload_blue",
    "data-name": "Icon feather-upload blue",
    transform: "translate(-3.75 -3.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28707",
    "data-name": "Path 28707",
    d: "M14.775,22.5v2.283a1.142,1.142,0,0,1-1.142,1.142H5.642A1.142,1.142,0,0,1,4.5,24.783V22.5",
    transform: "translate(0 -11.15)",
    fill: "none",
    stroke: "#4c96ce",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28708",
    "data-name": "Path 28708",
    d: "M16.209,7.354,13.354,4.5,10.5,7.354",
    transform: "translate(-3.717)",
    fill: "none",
    stroke: "#4c96ce",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28709",
    "data-name": "Path 28709",
    d: "M18,4.5v6.85",
    transform: "translate(-8.362)",
    fill: "none",
    stroke: "#4c96ce",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIconBlue);
export default __webpack_public_path__ + "static/media/uploadIconBlue.24e03d6388093b60783607a9210fc04a.svg";
export { ForwardRef as ReactComponent };